export enum DocumentCode {
    // admin-web
    USER = 'USER',
    WPLC = 'WPLC',
    ITG = 'ITG',

    // mes-web
    SALE = 'SALE',
    WO = 'WO',
    DSG = 'DSG',
    MES = 'MES',

    // aps-web
    PLAN = 'PLAN',

    // documents-web
    QC = 'QC',
    UGM = 'UGM',
    TOOL = 'TOOL',
    WIP = 'WIP',
    TECH = 'TECH',
}
export type IApiDocument = {
    id: number,
    documentCode: DocumentCode,
    documentKey: string,
    title: string,
    data: any,
}

export type IApiGetDocumentListParams = {
    searchText: string,
}